import React from 'react'
import { css } from '@emotion/core'

export const HEADINGS_FONT_STACK =
  "'HeritageHeadings:Sans', 'HanaMinBFont', ui-sans-serif, system-ui, sans-serif, 'Tofu'"

export const DOT_CYCLE_MS = 1400

export const activityLoadingTextCss = css`
  font-family: var(--font-families-headings, ${HEADINGS_FONT_STACK});
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  position: absolute;
  inset-inline: 32px;
  top: 50%;
  top: 50lvh;
  transform: translateY(-50%);
`

/**
 * The dots stay in the layout at all times and only their opacity moves, so the label never reflows
 * and the text beside them cannot jiggle.
 *
 * The @media here is for prefers-reduced-motion, not a width breakpoint — widths still go through
 * zion's atWidth.
 */
export const loadingDotsCss = css`
  @keyframes activity-loading-dot {
    0%,
    80%,
    100% {
      opacity: 0.25;
    }
    40% {
      opacity: 1;
    }
  }

  > span {
    animation: activity-loading-dot ${DOT_CYCLE_MS}ms ease-in-out infinite;
  }

  > span:nth-of-type(2) {
    animation-delay: ${Math.round(DOT_CYCLE_MS * 0.16)}ms;
  }

  > span:nth-of-type(3) {
    animation-delay: ${Math.round(DOT_CYCLE_MS * 0.32)}ms;
  }

  @media (prefers-reduced-motion: reduce) {
    > span {
      animation: none;
      opacity: 1;
    }
  }
`

/**
 * Three dots that pulse in turn, to sit after a dots-free loading word.
 *
 * Hidden from assistive tech: the label's own live region already announces the word, and three
 * animating full stops carry no meaning.
 */
export default function LoadingDots() {
  return (
    <span css={loadingDotsCss} aria-hidden="true">
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  )
}
